import * as _ from 'lodash';
// import * as jQuery from 'jquery';
import * as Velocity from 'velocity-animate';
import * as lottie from 'lottie-web';
import 'owl.carousel';

const $ = jQuery;
const md = 992;

$(document).ready(() => {

  checkRetrunOffset();
  window.onpopstate = copyReturnOffset;
  $('.subpage__close').on('click', copyReturnOffset);

  $('.slider').owlCarousel({
    items: 1,
    dots: true,
    loop: true,
    navContainer: '.slider__button__wrapper',
    navText: ['', '']
  });

  $('.big-slider').owlCarousel({
    items: 1,
    dots: true,
    loop: true,
    navContainer: '.big-slider__button__wrapper',
    navText: ['', '']
  });




  $('.nav__toggle').on('click', function () {
    $(this).toggleClass('active');
    const navMain = $('.header__menu__wrapper');
    const active = $(this).hasClass('active');

    $('body').toggleClass('nav-active', active);

    if (active) {
      if (!isNavAtTop()) {
        $('html, body').animate({
          scrollTop: ($('#main-top').offset().top)
        }, 500);
      }
      $('html').css('overflow', 'hidden');
      Velocity(navMain, 'slideDown');
    } else {
      $('html').css('overflow', 'auto');
      Velocity(navMain, 'slideUp');
    }
  });

  const onResize = () => {
    const width = $(window).width();

    if (width >= md) {
      $('body').toggleClass('nav-active', false);
      $('.nav__toggle').toggleClass('active', false);
      $('.header__menu__wrapper').css('display', '');
      $('html').css('overflow', 'auto');
    }
  }

  $(window).on('resize', _.debounce(onResize, 500));

  $(document).on('click', 'a[href^="#"]', function (event: any) {
    event.preventDefault();

    $('html, body').animate({
      scrollTop: ($($.attr(this, 'href')).offset().top) - 80
    }, 500);
  });

  const animationElements = $('.intro__animation__wrapper');

  for (const animation of Array.from(animationElements)) {
    let animationPath = $(animation).data('path');
    const ani: any = lottie.loadAnimation({
      container: animation,
      renderer: 'svg',
      loop: true,
      autoplay: true,
      path: animationPath
    });
  }

  setInterval(animate, 2000);

  $('.color-box').on('click', function () {
    localStorage.setItem('stored-return-offset', window.pageYOffset as any);
  });

  $('.picture-box').on('click', function () {
    $('.hover-box').trigger('hover');
  });
});

function checkRetrunOffset() {
  const currentReturnOffset = localStorage.getItem('current-return-offset') as any;
  localStorage.setItem('current-return-offset', null);

  if (currentReturnOffset != null) {
    window.scrollTo(0, currentReturnOffset);
  }
}

function copyReturnOffset() {
  const offset = localStorage.getItem('stored-return-offset');
  localStorage.setItem('current-return-offset', offset);
}

function isNavAtTop() {
  const top = $('#main-top').offset().top;

  if ($(window).scrollTop() >= top) {
    return true;
  } else {
    return false;
  }
}

function animate() {
  $('.color-box__image__wrapper').toggleClass('active');
}
